import { FileQuestion } from "lucide-react";

type NotAccessiblePanelProps = {
  message?: string;
  onBack?: () => void;
};

export function NotAccessiblePanel({ message, onBack }: NotAccessiblePanelProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-border bg-surface p-8 text-center">
      <FileQuestion className="h-12 w-12 text-muted-foreground" />
      <h3 className="mt-4 text-lg font-semibold text-text">Introuvable ou non accessible</h3>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">
        {message ?? "Cette ressource n'existe pas ou vous n'avez pas accès à celle-ci."}
      </p>
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="mt-6 rounded-md bg-accent px-4 py-2 text-sm font-medium text-white hover:bg-accent-hover"
        >
          Retour
        </button>
      )}
    </div>
  );
}
